module.exports = __webpack_public_path__ + "static/pipeline-code-2-3e1f3ae0675ff6e67d628443b19c9f86.png";